import React from 'react';
import { Button } from '../../ui/button';
import { ArrowLeft, Cake } from 'lucide-react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { dateToInputValue, inputValueToDate, normalizeDateValue } from '../../../utils/formatters';

interface BirthdayStepProps {
  birthday: Date | null;
  onBirthdayChange: (date: Date | null) => void;
  onNext: () => void;
  onBack: () => void;
}

export function BirthdayStep({ birthday, onBirthdayChange, onNext, onBack }: BirthdayStepProps) {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (!value) {
      onBirthdayChange(null);
      return;
    }

    value = normalizeDateValue(value);
    onBirthdayChange(inputValueToDate(value));
  };

  return (
    <div className="space-y-8">
      <div className="text-center space-y-3">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-almost-gold/10 mb-2">
          <Cake className="w-8 h-8 text-almost-gold" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">When's your birthday?</h2>
        <p className="text-lg text-muted-foreground">We'll make sure your team knows when to celebrate</p>
      </div>

      <div className="flex justify-center">
        <div className="w-full max-w-sm space-y-2">
          <Label htmlFor="birthday" className="sr-only">Birthday</Label>
          <Input
            id="birthday"
            type="date"
            value={dateToInputValue(birthday)}
            onChange={handleDateChange}
            max={new Date().toISOString().split('T')[0]}
            className="text-center text-lg h-14"
          />
        </div>
      </div>

      <div className="flex items-center justify-between pt-8">
        <Button variant="ghost" onClick={onBack} className="gap-2">
          <ArrowLeft className="w-4 h-4" />
          Back
        </Button>
        <Button onClick={onNext} className="rounded-full px-8">
          {birthday ? 'Confirm' : 'Next'}
        </Button>
      </div>
    </div>
  );
}
